import { createContext, useContext } from 'react';
import { useDeckStore } from '@/store';

// The presentation is shared. A native workspace supplies its local storage
// and execution renderer without converting native IDs into cloud chats.
export const DeckDataContext = createContext(null);
const defaultBinding = { store: useDeckStore, routePath: '/deck', localColumn: null };
export function useDeckBinding() { return useContext(DeckDataContext) || defaultBinding; }
